module.exports = __webpack_public_path__ + "img/mc.3b549224.svg";